import {useMemo} from 'react';
import {shallowEqual} from 'react-redux';
import type {ManifestationStatus} from 'services/metadata/types';
import {useAppSelector} from 'store/hooks';
import {
  selectMetadataEditEditStatuses,
  selectMetadataEditStatuses,
} from '../metadataEditSlice';

export const useStatusAndShowError = (
  id: string,
): {
  activeStatus: ManifestationStatus;
  status: ManifestationStatus;
  changedStatus?: ManifestationStatus;
  showError: boolean;
} => {
  const metadataStatus = useAppSelector(
    state => selectMetadataEditStatuses(state)[id],
    shallowEqual,
  );
  const editStatus = useAppSelector(
    state => selectMetadataEditEditStatuses(state)[id],
    shallowEqual,
  );

  return useMemo(() => {
    return {
      activeStatus:
        metadataStatus.previewStatus ??
        metadataStatus.changedStatus ??
        metadataStatus.status,
      status: metadataStatus.status,
      changedStatus: metadataStatus.changedStatus,
      showError: !!(
        metadataStatus.previewStatus ||
        metadataStatus.changedStatus ||
        (editStatus?.isSaving ?? false)
      ),
    };
  }, [editStatus, metadataStatus]);
};
